<template>
  <div class="form-group">
    <label>{{ prop.name }}</label>
    <textarea :id="prop.pid" v-if="custprop.type == 'multiline'" rows="6" width="100%" class="form-control">
    </textarea>
    <input type="file" class="form-control" :placeholder="custprop.placeholder" :id="prop.pid" v-else-if="custprop.type=='smbfile'"/>
    <ArticleAutoCompleter :placeholder="custprop.placeholder" :iid="prop.pid" v-else-if="custprop.type=='article'"/>
    <CustomerAutoCompleter :placeholder="custprop.placeholder" :iid="prop.pid" v-else-if="custprop.type=='customer'"/>
    <OfferAutoCompleter :placeholder="custprop.placeholder" :iid="prop.pid" v-else-if="custprop.type=='offer'"/>
    <OrderAutoCompleter :placeholder="custprop.placeholder" :iid="prop.pid" v-else-if="custprop.type=='order'"/>
    <input :id="prop.pid" v-else-if="prop.type == 'boolean'" type="checkbox" class="form-check"/>
    <select :id="prop.pid" v-else-if="prop.type == 'enum' && prop.values" class="form-control">
      <option value="">-</option>
      <option v-for="(val,key) in prop.values" :key="key" :value="key">{{ val }}</option>
    </select>
    <input :id="prop.pid" v-else type="text" :placeholder="custprop.placeholder" class="form-control"/>
  </div>
</template>

<script>
import ArticleAutoCompleter from '@/components/articles/ArticleAutoCompleter.vue'
import CustomerAutoCompleter from '@/components/customer/CustomerAutoCompleter.vue'
import OfferAutoCompleter from '@/components/documents/OfferAutoCompleter.vue'
import OrderAutoCompleter from '@/components/documents/OrderAutoCompleter.vue'

export default {
  name: 'TaskFormField',
  props: ["prop","custprop"],
  components: {
    ArticleAutoCompleter,
    CustomerAutoCompleter,
    OfferAutoCompleter,
    OrderAutoCompleter,
  }
}
</script>
